export default "__VITE_ASSET__DrikVKOM__"